/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { RapportHopeGridDto } from './RapportHopeGridDto';
import {
    RapportHopeGridDtoFromJSON,
    RapportHopeGridDtoFromJSONTyped,
    RapportHopeGridDtoToJSON,
} from './RapportHopeGridDto';

/**
 * 
 * @export
 * @interface RapportHopeGridDtoPaginatedResults
 */
export interface RapportHopeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof RapportHopeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<RapportHopeGridDto>}
     * @memberof RapportHopeGridDtoPaginatedResults
     */
    results?: Array<RapportHopeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof RapportHopeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the RapportHopeGridDtoPaginatedResults interface.
 */
export function instanceOfRapportHopeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RapportHopeGridDtoPaginatedResultsFromJSON(json: any): RapportHopeGridDtoPaginatedResults {
    return RapportHopeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function RapportHopeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportHopeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(RapportHopeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function RapportHopeGridDtoPaginatedResultsToJSON(value?: RapportHopeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(RapportHopeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

